import NewChapterModal from "Modals/NewChapterModal.vue"
import NewsletterSubscriptionModal from "Modals/NewsletterSubscriptionModal.vue"


if ( document.getElementsByClassName( "app--marketingModals" ).length > 0 ) {
    // Modals controller
    // set to a global variable to act as its own event bus
    window.butterMarketingModals = new Vue({
        name: "ButterMarketingModal",
        el: ".app--marketingModals",
        components: {
            NewChapterModal,
            NewsletterSubscriptionModal,
        },
        methods: {
            requestModal ( data ) {
                this.$emit( "request:modal", data )
            },
        }
    })
}
